import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { getWarnings } from '../../selectors/validationSelectors';

const VariantErrorsWarning = () => {
  const { formatMessage } = useIntl();
  const warnings = useSelector(getWarnings);
  const hasWarnings = warnings.length > 0;

  return (
    <div role="alert" className="sr-only" id="search-hotels-sr-errors">
      { hasWarnings && warnings.map((warning) => (
        typeof warning === 'string'
          ? formatMessage({ id: `validation.${warning}` })
          : formatMessage({ id: `validation.${warning.key}` }, { value: warning.value })
      ))}
    </div>
  );
};

export default VariantErrorsWarning;
